import Vue from 'vue';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default (el) =>
  new Vue({
    el,
    data: () => ({
      showModal: false,
    }),
    methods: {
      openModal() {
        this.showModal = true;

        setTimeout(() => {
          disableBodyScroll(this.$refs.featuredVideo);
        });
      },
      closeModal() {
        this.showModal = false;
        clearAllBodyScrollLocks();
      },
    },
  });
